import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=95ee2ace&scoped=true&"
import script from "./Icon.vue?vue&type=script&lang=ts&"
export * from "./Icon.vue?vue&type=script&lang=ts&"
import style0 from "./Icon.vue?vue&type=style&index=0&id=95ee2ace&scoped=true&lang=css&"
import style1 from "./Icon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ee2ace",
  null
  
)

export default component.exports